import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory, QueryParams } from '@ngrx/data';
import { Observable } from 'rxjs/Observable';
import { adaptiveRuleEntityMetadata } from './adaptive-rule.entity';
import { AdaptiveRule } from './adaptive-rule.model';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class AdaptiveRulesService extends EntityCollectionServiceBase<AdaptiveRule> {

    constructor(private serviceElementsFactory: EntityCollectionServiceElementsFactory,
                private http: HttpClient) {
        super(adaptiveRuleEntityMetadata.entityName, serviceElementsFactory);
    }

    getWithQuery(parameters: string | QueryParams): Observable<any> {
        return super.getWithQuery(parameters);
    }

    canDeleteRule(userId: number, ruleName: string): Observable<any> {
        return this.http
            .get<{ locations: Array<String> }>(`servlets/adaptiverules/canDelete/${ruleName}?userId=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response)
            );
    }

    deleteRule(userId: number, ruleName: string): Observable<any> {
        return this.http
            .post<{ locations: Array<String> }>(`servlets/adaptiverules/deleteRule/${ruleName}?userId=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response)
            );
    }
}
